import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Southwest Florida Vacation Rentals';
const SITE_URL = 'https://southwestflvacationrentals.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-default.jpg`;

export default function SEO({
  title,
  description,
  image = DEFAULT_IMAGE,
  url,
  type = 'website'
}) {
  const fullTitle = title ? `${title} | SWFL Vacation Rentals` : SITE_NAME;
  const fullUrl = url ? `${SITE_URL}${url}` : SITE_URL;

  return (
    <Helmet>
      {/* Basic Meta */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
